import React from 'react';
import XIcon from '@mui/icons-material/X';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import Tooltip from '@mui/material/Tooltip';
import { Box, Link, Typography } from '@mui/material';
import startupindia from '../assets/images/startupindia-logo-whitebg.png'

const email = 'admin@iverto.ai'
const address = 'Third Floor, #88, The R.P. Towers, \nPollachi, Coimbatore, TN, IN'
const location = "https://maps.app.goo.gl/DmVENPXsnoZJE35B7"
// const phone = '0000000000'


function Footer() {
  const smlinks = [
    // {
    //   name: 'X',
    //   url: 'https://x.com/',
    //   icon: <XIcon />,
    //   color: '#000000'
    // },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/company/iverto-ai',
      icon: <LinkedInIcon />,
      color: '#0077b5'
    },
    // {
    //   name: 'Instagram',
    //   url: 'https://www.instagram.com/',
    //   icon: <InstagramIcon />,
    //   color: '#3f729b'
    // },
    // {
    //   name: 'Facebook',
    //   url: 'https://www.facebook.com/',
    //   icon: <FacebookIcon />,
    //   color: '#3b5998'
    // },
    // {
    //   name: 'Youtube',
    //   url: 'https://www.youtube.com/@',
    //   icon: <YouTubeIcon />,
    //   color: '#cd201f'
    // },
    // {
    //   name: 'Github',
    //   url: 'https://github.com/',
    //   icon: <GitHubIcon />,
    //   color: '#00405d'
    // },
    // {
    //   name: "Reddit",
    //   url: "",
    //   icon: <RedditIcon />,
    //   color: '#ff4500'
    // },
  ];


  return (
    <Box
      id="footer"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: '60px',
        paddingBottom: '30px',
        flexDirection: 'column',
        width: '100%',
        gap: 3,
      }}
    >
      Recognised by
      <Box
        component='img'
        src={startupindia}
        alt="Startup India Logo"
        sx={{ width: '200px', objectFit: 'cover' }}
      ></Box>

      <iframe 
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3920.892424791499!2d77.00540877560914!3d10.665457461229645!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba839000c9a309b%3A0x6b2b17c0d660d554!2siverto.ai!5e0!3m2!1sen!2sin!4v1738137692854!5m2!1sen!2sin" 
        title='map'
        width="100%" 
        height="480p" 
        style={{border:0}} 
        allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"
      />
      <Link
          href={location}
          target="_blank"
          rel="noreferrer"
          sx={{
            '&:hover':{
              textDecoration: 'none',
              color: 'primary.dark',
            },
            display: 'flex',
            gap:1,
            justifyContent:'center',
          }}
        >
          <Typography
           sx={{
            textAlign: 'center',            
            gap: 'inheret'
           }}
          >
            <LocationOnIcon />
            {address}
          </Typography>
        </Link>
        <Link
          href={"mailto:"+email}
          target="_blank"
          rel="noreferrer"
          sx={{
            '&:hover':{
                textDecoration: 'none',
                color: 'primary.dark'
              },
            display: 'flex',
            gap:1
          }}
        >
          <EmailIcon/>
          {email}
        </Link>
        {/* <Link
          href={"tel:"+phone}
          target="_blank"
          rel="noreferrer"
          sx={{
            '&:hover':{
                textDecoration: 'none',
                color: 'primary.dark',
              },
            display: 'flex',
            gap:1
          }}
        >
          <CallIcon/>
          91 {phone}
        </Link> */}

  
        <Box
          sx={{
            marginY:'30px',
            display: 'flex',
            // justifyContent: 'center',
            // alignItems: 'center',
            gap: 2,
          }}
        >
          {smlinks.map((link, i) => (
            <a
              key={i}
              style={{ color: link.color, textDecoration: 'none' }}
              rel="noreferrer"
              target="_blank"
              href={link.url}
            >
              <Tooltip title={link.name} placement="top">
                {link.icon}
              </Tooltip>
            </a>
          ))}

        </Box>


        {/* <Box
          sx={{
            display: 'flex',
            flexDirection: {
              sm: 'column',
              md: 'row',
            },
            gap: 2,
            justifyContent: 'center',
            alignItems:'center'

          }}
        >
          <Link href="/terms"
          sx={{
                '&:hover':{
                  textDecoration: 'none',
                  color: 'primary.dark'
                }
                }}
          >
            Terms of Service
          </Link>
          <Typography
          sx={{
            display:{
              sm: 'none',
              md: 'block'
            }
          }}
          >
            |
          </Typography>
          <Link className="privacy" href="/privacy"
          sx={{
                '&:hover':{
                  textDecoration: 'none',
                  color: 'primary.dark'
                }
                }}
          >
            Privacy Policy
          </Link>
        </Box> */}


        <Box
        sx={{
          marginY: '30px'
        }}
        >
          <strong className="fi"> &copy; {new Date().getFullYear()} iverto.ai</strong>
        </Box>
    </Box>
  );
}

export default Footer;

